import { ExecutionPath } from '../index';
import { Activity, ProcessExecutionStatus } from '@ispm-shared/modules/bpmn';
import { GuideBox } from 'diagram-js/lib/model';
import { BpmnDeploymentIdentifier } from '@ispm-shared/modules/bpmn';
import { TreeNavigationConfiguration } from '@ispm-client/modules/process-executor/models/tree-navigation-configuration';
import { NodeDependencies } from '@ispm/shared/bpmn/models/node-dependencies';


export enum BP_Status { NotStarted, InProgress, Completed}
export enum USER_SELECTION_STATUS { InProgress, NotInProgress}

export interface State {
  bpmnDeploymentIdentifier?: BpmnDeploymentIdentifier;
  bpmnXml?: string;
  processInstanceId?: string;
  executedActivities?: Activity[] | null;
  executionHistoryParsingStatus?: BP_Status;
  bpmnXmlParsingStatus?: BP_Status;
  executionPath?: ExecutionPath;
  selectedTreatmentNodeId?: string;
  processExecutionStatus?: ProcessExecutionStatus;
  nodesNamesSuffixes?: any;
  guidedBoxes?: { [nodeId: string]: GuideBox};
  nodeSelectionDependencies?: NodeDependencies;
  patientData?: any;
  latestSelectedNodeId?: string;
  handelingUserSelectionStatus?: USER_SELECTION_STATUS;
  treeNavigationConf?: TreeNavigationConfiguration;
  mandatoryNotesVisited: string[];
}

export const initialState: State =  {
  bpmnDeploymentIdentifier: null,
  bpmnXml: null,
  processInstanceId: null,
  executedActivities: null,
  executionHistoryParsingStatus: BP_Status.NotStarted,
  bpmnXmlParsingStatus: BP_Status.NotStarted,
  executionPath: null,
  selectedTreatmentNodeId: null,
  processExecutionStatus: null,
  nodesNamesSuffixes: null,
  guidedBoxes: null,
  nodeSelectionDependencies: null,
  patientData: null,
  latestSelectedNodeId: null,
  handelingUserSelectionStatus: USER_SELECTION_STATUS.NotInProgress,
  treeNavigationConf: null,
  mandatoryNotesVisited: null
};
